// @flow
import React, { Fragment } from 'react'
import Hidden from '@material-ui/core/Hidden';
import LineTo, { SteppedLineTo } from 'react-lineto';
import LineAnchor from '../components/core/LineAnchor';
import { lineColor } from '../styles/style-constants';
import { remCalc } from './style-util';
import { xPaddingDefault } from '../styles/style-constants';

const defaultLeftPadding = xPaddingDefault - 50;

const renderAnchorPoint = (name, filled, top, xPosition) => {
  const container = {
    position: 'relative'
  };

  const style = {
    position: 'absolute',
    top: remCalc(top),
    zIndex: 100,
    ...xPosition
  };

  return (
    <Hidden mdDown>
      <div className="lineAnchorContainer" style={container}>
        <LineAnchor name={name} style={style} filled={filled} />
      </div>
    </Hidden>
  );
};

const renderAnchorHelper = (name, filled, stepped, top, xPosition) => {
  if (filled && xPosition.left) {
    const adjust = stepped ? -1.5 : 1;
    return (
      <Fragment>
        {renderAnchorPoint(`${name}Dot`, true, top, xPosition )}
        {renderAnchorPoint(name, false, top, { left: xPosition.left + adjust })}
      </Fragment>
    );
  }

  return renderAnchorPoint(name, filled, top, xPosition);
}

const renderAnchor = (name, filled, top, xPosition = { left: defaultLeftPadding }) => {
  return renderAnchorHelper(name, filled, false, top, xPosition);
};

const renderSteppedAnchor = (name, filled, top, xPosition = { left: defaultLeftPadding }) => {
  return renderAnchorHelper(name, filled, true, top, xPosition);
};

// fromAnchor = 'bottom', toAnchor = 'top'
const LINE_END_POSITIONS = {
  "middleVerticalFrom": "50% 35%",
  "middleVerticalTo": "50% 60%",
  "middleHorizontalFrom": "40% 50%",
  "middleHorizontalTo": "35% 50%"
};

const renderLine = (from, to, fromAnchor = 'middle', toAnchor = 'middle') => {
  const fromPosition = LINE_END_POSITIONS[`${fromAnchor}From`] || fromAnchor;
  const toPosition = LINE_END_POSITIONS[`${toAnchor}To`] || toAnchor;

  return (
    <Hidden mdDown>
      <LineTo
        from={from}
        to={to}
        fromAnchor={fromPosition}
        toAnchor={toPosition}
        delay={true}
        borderColor={lineColor}
        borderWidth={3}
        borderStyle="solid"
      />
    </Hidden>
  );
}

const renderSteppedLine = (from, to, fromAnchor = 'middle', toAnchor = 'middle') => {
  return (
    <Hidden mdDown>
      <SteppedLineTo
        from={from}
        to={to}
        fromAnchor={fromAnchor}
        toAnchor={toAnchor}
        delay={true}
        borderColor={lineColor}
        borderWidth={3}
        borderStyle="solid"
      />
    </Hidden>
  );
}

export default {
  renderAnchor,
  renderSteppedAnchor,
  renderLine,
  renderSteppedLine
};



// WEBPACK FOOTER //
// ./src/util/path-line-util.js